import { useMutation, useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { APIError } from '../../../utils'
import { updatePayNowActiveStatus } from '../query-api'

interface UseUpdatePayNowActiveStatusProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useUpdatePayNowActiveStatus = ({ onError, onSuccess }: UseUpdatePayNowActiveStatusProps = {}) => {
  const queryClient = useQueryClient()

  const {
    mutate,
    isLoading: isProcessing,
    ...rest
  } = useMutation(updatePayNowActiveStatus, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeys.PayNowStatus])
      onSuccess?.()
    },
    onError,
  })

  return { updatePayNowActiveStatus: mutate, isProcessing, ...rest }
}
